export default __webpack_public_path__ + "static/media/76.ce589a98.jpg";